import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate, useResolvedPath } from 'react-router-dom';

import { usePostCompaniesMutation } from '@client/api';
import { Skeleton, useRouteDocumentTitle } from '@client/toolkit';

import { CompaniesPaths } from '../companies.router';
import { CompanySearchForm, CompanySearchFormData } from '../components/company-search.form';

export function CompanyCreateRoute() {
  const { t, ready } = useTranslation('companies');
  const navigate = useNavigate();

  const companyCreatePath = useResolvedPath(CompaniesPaths.CompanyCreate);
  useRouteDocumentTitle(
    t('companyCreate.documentTitle', { entity: t('global:entity.company') }),
    companyCreatePath.pathname,
  );

  const [postCompany] = usePostCompaniesMutation();

  const handleClose = () => {
    navigate(-1);
  };

  const handleSubmit = async (data: CompanySearchFormData) => {
    const { numberOfEmployees, ...rest } = data;
    await postCompany({ body: { ...rest, numberOfEmployees: numberOfEmployees ? parseInt(numberOfEmployees, 10) : null } })
      .unwrap()
      .then((company) => {
        if (company?.id != null) {
          navigate(generatePath(CompaniesPaths.Company, { id: company.id }), { replace: true });
        }
      });
  };

  return (
    <CompanySearchForm
      title={ready ? t('companyCreate.title', { entity: t('global:entity.company') }) : <Skeleton variant="text" />}
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  );
}
